import type { FaireProductEntity } from "../../entity_types/product";

export const p_dx8ssuqv2q: FaireProductEntity = {
  token: "p_dx8ssuqv2q",
  type: "product",
  name: "Spicy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/44aa9326f4b2c8908b28d8cfb162ee379be63ba349d97638d7e9a21e7439e227.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5ea11e87daaf23efa8907838a96776045b5488f3f5dbbcd40d9cbec5e1c56d6.jpeg",
    "https://cdn.faire.com/fastly/de222147cdf01c95e30a63c476f9ddf815627c29e0f08993427cf73611483218.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/7337e2db5377bea4c28eac01cd9ea7fd9479f73594f33e0df404c08eea643c49.jpeg",
    "https://cdn.faire.com/fastly/4bac9a3ccdd3090289be6a19be80a0b000003e74778208b84134e4ce8b58e9c5.jpeg",
    "https://cdn.faire.com/fastly/8d6f7deeb20b0e226806d6b445447a639775e0b53ad3239e121c951a97048399.jpeg",
    "https://cdn.faire.com/fastly/98b17950e2c9e89f9d222528f33fe37d3b76a3d1c7d07ca0ec769ac261b64d19.jpeg"
  ],
  priceDollars: 6.75,
  description: "These aren't for bland spirits. If you like zest, drama, and maybe sometimes make peoples' eyes water... you've found the right socks. 🌶️\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:54.925Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
